export default "__VITE_ASSET__6GxHYT6W__"